import { useState } from 'react';
import logoImage from '../../../assets/logo/logo_jp.png'

interface EnviaEmailProps {
  sendEmail: (email: string) => void
}

export const EnviaEmail = ({ sendEmail }: EnviaEmailProps) => {
  const [email, setEmail] = useState("");

  return (
    < div className="m-6" >
      <img src={logoImage} alt="" className='w-[350px] ml-28 my-8' />

      <p className='text-xl my-4'>Confirme seu e-mail para receber o código de recuperação de senha.</p>

      <form className='flex flex-col items-center my-4' >
        <input
          type="email"
          className="input-container border-2 text-gray-800"
          value={email}
          placeholder='email@email.com.br'
          onChange={(e) => setEmail(e.target.value)}
        />
        <button
          type="button"
          className="mt-8 h-11 w-full rounded-lg border-0 bg-primary text-lg font-normal uppercase text-white"
          onClick={() => sendEmail(email)}
        >Enviar</button>
      </form>

    </div >
  )

}